// extracted by mini-css-extract-plugin
export default {"PhotoBoard":"PhotoBoard_PhotoBoard__wTh8O","ItemContainer":"PhotoBoard_ItemContainer__Xrtg2"};